import React from 'react';

export const dash = (
  <g>
    <path d="M469.9,301.2H270.9V102.1c0-8.1-6.5-14.4-14.4-14.4c-125.7,0-228,102.4-228,227.8
            c0,125.7,102.4,227.8,227.8,227.8S484,440.9,484,315.6C484.3,307.7,477.8,301.2,469.9,301.2L469.9,301.2z M256.5,514.6
            c-109.7,0-199.1-89.4-199.1-199.1c0-104.8,81.5-190.9,184.4-198.5v198.5c0,8.1,6.5,14.4,14.4,14.4h198.5
            C447.5,433.1,361.3,514.6,256.5,514.6L256.5,514.6z"/>
    <path d="M539,260c-0.3-55.2-20.6-108.6-57.1-150c-43.1-49-105.3-76.9-170.6-76.9c-8.1,0-14.4,6.5-14.4,14.4v213.4
            c0,8.1,6.5,14.4,14.4,14.4h213.4c8.1,0,14.4-6.5,14.4-14.4L539,260L539,260z M325.6,246.5V62.6c51.7,3.8,100.2,27.6,134.6,66.9
            c29,32.8,46,73.9,49.3,117.3H325.6V246.5z"/>
  </g>
);

export const generalSection = (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 384 512"><path fill="#FDD2C6" d="M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64
     0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1
     0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72
     368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"/></svg>
);

export const tours = (
  <path d="M27.6,32.7c-14.3,0-25.5,11.2-25.5,25.5v71.5c0,8.2,7.1,15.3,15.3,15.3H23c2.3,11.8,12.5,20.4,25,20.4
			c12.5,0,22.7-8.6,25-20.4h62.3c2.3,11.8,12.5,20.4,25,20.4c12.8,0,23.1-9.1,25.1-21.3c6-2.1,10.6-7.9,10.6-14.4v-19.4
			c0-2,0-3.1-1-5.1l-12.3-30.6c-5.1-13.3-18.4-22.5-33.7-22.5H134c-2.7-11.2-12.6-19.4-24.7-19.4L27.6,32.7L27.6,32.7z M160.3,155.2
			c-8.2,0-15.3-7.1-15.3-15.3s7.1-15.3,15.3-15.3c8.2,0,15.3,7.1,15.3,15.3S168.5,155.2,160.3,155.2L160.3,155.2z M160.3,114.3
			c-12.5,0-22.7,8.6-25,20.4h-0.5V62.3h14.3c10.2,0,19.4,6.1,23.5,16.3l12.3,30.6v19.4c0,0.9-0.2,1.7-0.6,2.4
			C180.7,121.2,171.5,114.3,160.3,114.3L160.3,114.3z M48,155.2c-8.2,0-15.3-7.1-15.3-15.3s7.1-15.3,15.3-15.3
			c8.2,0,15.3,7.1,15.3,15.3S56.2,155.2,48,155.2L48,155.2z M12.3,58.2c0-8.2,7.1-15.3,15.3-15.3h81.7c8.2,0,15.3,7.1,15.3,15.3
			v76.6H73c-2.3-11.8-12.5-20.4-25-20.4c-12.5,0-22.7,8.6-25,20.4h-5.6c-3.1,0-5.1-2-5.1-5.1C12.3,129.7,12.3,58.2,12.3,58.2z" />
);

export const planning = (
  <>
    <g>
      <g>
        <path className="st0" d="M108,226.7c0-5.2,1.3-10,3.5-14.3H57.9c-6.8,0-13.1,4.3-15.1,10.9c-3.1,10.1,4.9,19.7,14.6,19.7h55
			C109.7,238.2,108,232.6,108,226.7z" />
        <path className="st0" d="M502.8,212.3h-77.5h-19.8H167.2c2.2,4.3,3.5,9.2,3.5,14.3c0,6-1.7,11.5-4.5,16.3h239.4h19.8h77.8
			c8.2,0,15-6.8,15-15.3C518,219.3,511,212.3,502.8,212.3z" />
      </g>
      <g>
        <path className="st0" d="M140,203c13.2,0,24,10.8,24,24s-10.8,24-24,24s-24-10.8-24-24S126.8,203,140,203 M140,177
			c-27.6,0-50,22.4-50,50s22.4,50,50,50s50-22.4,50-50S167.6,177,140,177L140,177z" />
      </g>
    </g>
    <g>
      <g>
        <path className="st0" d="M246,346.7c0-5,1.2-9.6,3.2-13.8H57.9c-6.8,0-13.1,4.3-15.1,10.9c-3.1,10.1,4.9,19.7,14.6,19.7h193.4
			C247.8,358.6,246,352.9,246,346.7z" />
        <path className="st0" d="M502.8,332.9h-75.3h-22h-100c2,4.2,3.2,8.8,3.2,13.8c0,6.2-1.8,11.9-4.9,16.8h101.7h22h75.6
			c4.1,0,8-1.7,10.9-4.7c2.8-2.9,4.2-6.7,4.1-10.6C518,339.9,511,332.9,502.8,332.9z" />
      </g>
      <g>
        <path className="st0" d="M278,323c13.2,0,24,10.8,24,24s-10.8,24-24,24s-24-10.8-24-24S264.8,323,278,323 M278,297
			c-27.6,0-50,22.4-50,50s22.4,50,50,50s50-22.4,50-50S305.6,297,278,297L278,297z" />
      </g>
    </g>
    <g>
      <path className="st0" d="M42.9,464.3c-3.1,10.1,4.9,19.7,14.6,19.7h371.3v-1.1V482v-26.6v-1.1v-0.9H57.9
		C51.1,453.4,44.9,457.7,42.9,464.3z" />
      <g>
        <path className="st0" d="M468,443c13.2,0,24,10.8,24,24s-10.8,24-24,24s-24-10.8-24-24S454.8,443,468,443 M468,417
			c-27.6,0-50,22.4-50,50s22.4,50,50,50s50-22.4,50-50S495.6,417,468,417L468,417z" />
      </g>
    </g>
    <g>
      <path className="st0" d="M502.8,91.8h-97.3c-1.5,0-2.9,0.2-4.3,0.6c2.2,4.3,3.4,9.1,3.4,14.3c0,5.4-1.4,10.5-3.8,15
		c1.5,0.5,3,0.8,4.6,0.8h97.6c8.2,0,15-6.8,15-15.3C518,98.8,511,91.8,502.8,91.8z" />
      <g>
        <g>
          <path className="st0" d="M342,106.7c0-5.4,1.4-10.4,3.7-14.9H57.9c-6.8,0-13.1,4.3-15.1,10.9c-3.1,10.1,4.9,19.7,14.6,19.7h288.7
				C343.5,117.8,342,112.4,342,106.7z" />
          <path className="st0"
            d="M400.9,91.8c2.4,4.4,3.7,9.5,3.7,14.9c0,5.7-1.5,11.1-4.2,15.7h21.2v-1.1v-0.9V93.8v-1.1v-0.9H400.9z" />
        </g>
        <g>
          <path className="st0" d="M374,83c13.2,0,24,10.8,24,24s-10.8,24-24,24s-24-10.8-24-24S360.8,83,374,83 M374,57c-27.6,0-50,22.4-50,50
				s22.4,50,50,50s50-22.4,50-50S401.6,57,374,57L374,57z" />
        </g>
      </g>
    </g>
  </>
);

export const adr = (
  <>
    <path
      d="m0 0 41.28-41.28L82.8 0 41.28 41.46 0 0"
      fill="#da251d"
      fillOpacity="1"
      fillRule="evenodd"
      stroke="none"
      transform="matrix(1.25 0 0 -1.25 0 51.825)"
    />
    <path
      d="M398.00177 757.76575h20.4v-2.1h-20.4v2.1z"
      fill="#1f1a17"
      fillOpacity="1"
      fillRule="nonzero"
      stroke="none"
      transform="translate(-355.70177 -711.34075)"
    />
    <path
      d="m0 0 .72.24.72.72.48 1.68.24 1.68v.72l.96-1.92.24-2.16V-.96l-.72-1.68 1.2.72.96.96.72 1.44c1.207-3.593.88-4.381-1.2-7.44L6-6.48l.96.72.24.72v.48l-.24-3.36-.72-2.4-1.2-1.92-1.44-.96-1.44-.72-1.44-.24h-1.2l.48.24.96.72 1.44 1.44L3.6-9.6l-1.2-.72-.96-.24H.48l.48.48.72.96.48 1.44v2.16l-.48-1.2-1.44-.96-.72-.72v2.88L-.96-3.6l-.96 1.44-.96.96v-1.92L-3.84-6v-.96l.24-1.44-.96.48-.72.48-.48.72-.48 1.2v-1.2l-.24-.96.48-1.2.48-.72.72-.96-1.68.24-.72.24-.96.72.96-2.16 1.44-1.68 1.44-.72 1.68-.24-3.6.24-2.4.96-1.68 1.2-.96 1.68-1.44 5.04-.24 1.44.72-.72.72-.96.96-.72 1.68-.24c-2.175 3.78-1.014 4.192-1.68 7.92l.96-.96.48-.72.72-.96.96-.72-.48 1.44v1.2l.24 1.92.24 1.2-.24 1.2.96-.24.48-.48.48-1.2.24-1.44.72-1.44c2.068 3.688.374 6.789 1.92 10.08l.48-2.4 1.44-2.64L0 2.88l.24-1.44L0 0"
      fill="#1f1a17"
      fillOpacity="1"
      fillRule="evenodd"
      stroke="none"
      transform="matrix(1.25 0 0 -1.25 55.5 24.525)"
    />
    <text
      transform="matrix(.99773 0 0 1.00228 -355.70177 -711.34075)"
      x="404.62067"
      y="795.25513"
      fontSize="14.96593475px"
    >
      <tspan
        style={{
          fontSize: '12.56265545px',
          fontVariant: 'normal',
          fontWeight: 700,
          fontStretch: 'normal',
          writingMode: 'lr-tb',
          fill: '#1f1a17',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          fontFamily: 'Arial',
        }}
        x="404.62067"
        y="795.25513"
      >
        3
      </tspan>
    </text>
    <path
      d="m-9746.9675 618.22734 45.225 45 45-45-45-44.925-45.225 44.925z"
      fill="none"
      stroke="#1f1a17"
      strokeWidth=".89874995"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeOpacity="1"
      transform="translate(9753.60523 -566.55234)"
    />
  </>
);

export const adrMono = (
  <>
    <path
      d="m0 0 41.28-41.28L82.8 0 41.28 41.46 0 0"
      fill="none"
      fillRule="evenodd"
      stroke="none"
      transform="matrix(1.25 0 0 -1.25 0 51.825)"
    />
    <path
      d="M398.00177 757.76575h20.4v-2.1h-20.4v2.1z"
      fill="currentColor"
      fillOpacity="1"
      fillRule="nonzero"
      stroke="none"
      transform="translate(-355.70177 -711.34075)"
    />
    <path
      d="m0 0 .72.24.72.72.48 1.68.24 1.68v.72l.96-1.92.24-2.16V-.96l-.72-1.68 1.2.72.96.96.72 1.44c1.207-3.593.88-4.381-1.2-7.44L6-6.48l.96.72.24.72v.48l-.24-3.36-.72-2.4-1.2-1.92-1.44-.96-1.44-.72-1.44-.24h-1.2l.48.24.96.72 1.44 1.44L3.6-9.6l-1.2-.72-.96-.24H.48l.48.48.72.96.48 1.44v2.16l-.48-1.2-1.44-.96-.72-.72v2.88L-.96-3.6l-.96 1.44-.96.96v-1.92L-3.84-6v-.96l.24-1.44-.96.48-.72.48-.48.72-.48 1.2v-1.2l-.24-.96.48-1.2.48-.72.72-.96-1.68.24-.72.24-.96.72.96-2.16 1.44-1.68 1.44-.72 1.68-.24-3.6.24-2.4.96-1.68 1.2-.96 1.68-1.44 5.04-.24 1.44.72-.72.72-.96.96-.72 1.68-.24c-2.175 3.78-1.014 4.192-1.68 7.92l.96-.96.48-.72.72-.96.96-.72-.48 1.44v1.2l.24 1.92.24 1.2-.24 1.2.96-.24.48-.48.48-1.2.24-1.44.72-1.44c2.068 3.688.374 6.789 1.92 10.08l.48-2.4 1.44-2.64L0 2.88l.24-1.44L0 0"
      fill="currentColor"
      fillOpacity="1"
      fillRule="evenodd"
      stroke="none"
      transform="matrix(1.25 0 0 -1.25 55.5 24.525)"
    />
    <text
      transform="matrix(.99773 0 0 1.00228 -355.70177 -711.34075)"
      x="404.62067"
      y="795.25513"
      fontSize="14.96593475px"
    >
      <tspan
        style={{
          fontSize: '12.56265545px',
          fontVariant: 'normal',
          fontWeight: 900,
          fontStretch: 'normal',
          writingMode: 'lr-tb',
          fill: 'currentColor',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          fontFamily: 'Arial',
        }}
        x="404.62067"
        y="795.25513"
      >
        3
      </tspan>
    </text>
    <path
      d="m-9746.9675 618.22734 45.225 45 45-45-45-44.925-45.225 44.925z"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeDasharray="none"
      strokeOpacity="1"
      transform="translate(9753.60523 -566.55234)"
    />
  </>
);

export const map = (
  <>
    <path d="M183,15.9v166.5H16.5V15.9H183 M183,8.9H16.5c-3.9,0-7,3.1-7,7v166.5c0,3.9,3.1,7,7,7H183c3.9,0,7-3.1,7-7V15.9
	C190,12.1,186.9,8.9,183,8.9L183,8.9z"/>
    <g>
      <path d="M122.4,66.1c-0.8,0-1.6-0.3-2.3-0.8c-8.7-7-12.7-13.6-14.5-17.9c-0.5-1.1-0.9-2.3-1.2-3.6
		c-0.1-0.3-0.1-0.5-0.1-0.6c-0.2-1.1-0.3-2.3-0.3-3.5c0-10.2,8.3-18.5,18.5-18.5S141,29.5,141,39.6c0,1.1-0.1,2.3-0.3,3.5l0,0
		c0,0,0,0.2-0.1,0.6c-0.3,1.2-0.7,2.5-1.2,3.7c-1.8,4.2-5.8,10.8-14.5,17.8C124,65.8,123.2,66.1,122.4,66.1z M122.4,26.3
		c-7.4,0-13.5,6-13.5,13.5c0,0.9,0.1,1.7,0.2,2.5v0.1c0,0,0,0.1,0.1,0.3c0.2,0.9,0.5,1.8,0.9,2.6c1.6,3.7,4.9,9.3,12.2,15.3
		c7.3-6.1,10.7-11.6,12.2-15.2c0.4-0.9,0.7-1.8,0.9-2.7c0-0.2,0.1-0.3,0.1-0.4c0.2-0.9,0.3-1.8,0.3-2.6
		C135.8,32.3,129.8,26.3,122.4,26.3z"/>
    </g>
    <g>
      <path d="M154.3,166.8c-0.8,0-1.6-0.3-2.3-0.8c-8.7-7-12.7-13.6-14.5-17.9c-0.5-1.1-0.9-2.3-1.2-3.6
		c-0.1-0.3-0.1-0.5-0.1-0.6c-0.2-1.1-0.3-2.3-0.3-3.4c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.4c0,1.1-0.1,2.3-0.3,3.4
		c0,0.1-0.1,0.3-0.1,0.6c-0.3,1.2-0.7,2.5-1.2,3.6c-1.8,4.2-5.8,10.8-14.5,17.8C155.9,166.5,155.1,166.8,154.3,166.8z M154.3,127
		c-7.4,0-13.5,6-13.5,13.5c0,0.9,0.1,1.7,0.2,2.5v0.1c0,0,0,0.2,0.1,0.4c0.2,0.9,0.5,1.8,0.9,2.6c1.6,3.7,4.9,9.3,12.2,15.3
		c7.3-6.1,10.7-11.6,12.2-15.2c0.4-0.9,0.7-1.8,0.9-2.7c0-0.2,0.1-0.3,0.1-0.4c0.2-0.9,0.3-1.8,0.3-2.6
		C167.8,133,161.7,127,154.3,127z"/>
    </g>
    <g>
      <path d="M122.4,48.3c-4.7,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6S127.1,48.3,122.4,48.3z M122.4,35.1
		c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6S124.9,35.1,122.4,35.1z"/>
    </g>
    <g>
      <path d="M57.5,121.6c-0.8,0-1.6-0.3-2.3-0.8c-8.7-7-12.7-13.6-14.5-17.9c-0.5-1.1-0.9-2.3-1.2-3.6
		c-0.1-0.3-0.1-0.5-0.1-0.6c-0.2-1.1-0.3-2.3-0.3-3.4c0-10.2,8.3-18.5,18.5-18.5s18.5,8.3,18.5,18.4c0,1.1-0.1,2.3-0.3,3.4
		c0,0.1-0.1,0.3-0.1,0.6c-0.3,1.2-0.7,2.5-1.2,3.6c-1.8,4.2-5.8,10.8-14.5,17.8C59.1,121.3,58.3,121.6,57.5,121.6z M57.5,81.8
		c-7.4,0-13.5,6-13.5,13.5c0,0.9,0.1,1.7,0.2,2.5v0.1c0,0,0,0.2,0.1,0.4c0.2,0.9,0.5,1.8,0.9,2.6c1.6,3.7,4.9,9.3,12.2,15.3
		c7.3-6.1,10.7-11.6,12.2-15.2c0.4-0.9,0.7-1.8,0.9-2.7c0-0.2,0.1-0.3,0.1-0.4c0.2-0.9,0.3-1.8,0.3-2.6
		C70.9,87.8,64.9,81.8,57.5,81.8z"/>
    </g>
    <g>
      <path d="M57.5,103.7c-4.7,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6C66.1,99.9,62.2,103.7,57.5,103.7z
		 M57.5,90.5c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6S60,90.5,57.5,90.5z"/>
    </g>
    <g>
      <path d="M153.8,149.3c-4.7,0-8.6-3.9-8.6-8.6s3.9-8.6,8.6-8.6s8.6,3.9,8.6,8.6S158.6,149.3,153.8,149.3z M153.8,136.1
		c-2.5,0-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6S156.4,136.1,153.8,136.1z"/>
    </g>
    <g>
	
      <rect x="74.5" y="97.6" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -29.4773 129.1283)" className="st0" width="133.3" height="5"/>
    </g>
    <g>
      <rect x="0.1" y="48.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.8979 50.7814)" className="st0" width="101.5" height="5"/>
    </g>
    <g>
      <rect x="145" y="46.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.5399 123.6743)" className="st0" width="5" height="39.3"/>
    </g>
    <g>
      <rect x="41.9" y="2.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -16.6586 43.6745)" className="st0" width="5" height="78.9"/>
    </g>
    <g>
	
      <rect x="77.3" y="107.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -68.2961 94.4121)" className="st0" width="5" height="45.1"/>
    </g>
    <g>
      <rect x="24.9" y="56.6" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -46.5221 41.9416)" className="st0" width="5" height="41.1"/>
    </g>
    <g>
      <rect x="100.6" y="7.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 15.9494 78.3796)" className="st0" width="4" height="24.1"/>
    </g>
    <g>
	
      <rect x="104.2" y="167.7" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -82.6909 140.7228)" className="st0" width="48.7" height="5"/>
    </g>
    <g>
	
      <rect x="173" y="150.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -64.7544 172.1978)" className="st0" width="5" height="26.9"/>
    </g>
    <g>
	
      <rect x="139.7" y="42.3" transform="matrix(0.7071 -0.7071 0.7071 0.7071 17.0079 130.6523)" className="st0" width="53.1" height="5"/>
    </g>
    <g>
      <rect x="6.9" y="109.3" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -71.218 51.6976)" className="st0" width="39.8" height="5"/>
    </g>
    <g>
      <line x1="60.1" y1="78.5" x2="70.7" y2="68"/>
      <rect x="57.9" y="70.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -32.683 67.709)" className="st0" width="14.9" height="5"/>
    </g>
    <g>
      <path d="M27.4,186.2c-0.6,0-1.3-0.2-1.8-0.7c-1-1-1-2.6,0-3.5l52.9-52.9c1-1,2.6-1,3.5,0s1,2.6,0,3.5l-52.9,52.9
		C28.6,186,28,186.2,27.4,186.2z"/>
    </g></>
);
